module.exports = __webpack_public_path__ + "static/img/aboutAsbanner.fbe69b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutAsbanner.png
// module id = 22JI
// module chunks = 1